import moment from 'moment';
import React from 'react';
import { Table } from 'react-bootstrap';
import { useTable, useSortBy } from 'react-table';
import { PlusCircle, XCircle, CheckCircle, Star, Circle, MinusCircle } from 'react-feather';
import filter from './filter.svg';
import Bolt from './lightning-bolt.svg';
import GoldStar from './star.svg';
import EquifaxIcon from '../../../assets/img/equifax.png';
import TransUnionIcon from '../../../assets/img/transunion.png';
import ExperianIcon from '../../../assets/img/experian.png';
import AscSort from '../asc-sort.svg';
import DescSort from '../desc-sort.svg';
import IndisputeIcon from './in-dispute-icon.svg';
const InDispute = ({ dispute_letter_right_list }) => {
  const getIconBeuro = type => {
    if (type === 'Negative') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-red rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <XCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'Not Reporting') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100 visibility-hidden'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-violet rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <PlusCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'DELETED') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-green rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <XCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'New Negative') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-red rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <XCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'VERIFIED') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-red rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <CheckCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'REPAIRED') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-items-center p-1 bg-icon-green rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <CheckCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else if (type === 'DND') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px', backgroundColor: '#F06BB3' }} className='align-items-center p-1 rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <MinusCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>NOT DISPUTING</span>
        </div>
      );
    } else if (type === 'IN DISPUTE') {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100'>
          <div stroke='none' style={{ width: '28px', height: '28px', backgroundColor: '#FBC02A' }} className='align-items-center p-1 rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <style>
              {`
              .icon-spin {
                animation: spin 4s infinite linear;
              }

              @keyframes spin {
                0% {
                  transform: rotate(0deg);
                }
                100% {
                  transform: rotate(360deg);
                }
              }
              `}
            </style>
            <img src={IndisputeIcon} className='text-white icon-spin' strokeWidth={2} style={{ height: '20px' }} />
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>{type}</span>
        </div>
      );
    } else {
      return (
        <div className='d-flex flex-column justify-content-center flex-grow-1 w-100 visibility-hidden'>
          <div stroke='none' style={{ width: '28px', height: '28px', backgroundColor: '#F06BB3' }} className='align-items-center p-1 rounded-circle bg-opacity-50 d-flex shadow mx-auto'>
            <MinusCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />{' '}
          </div>
          <span className='text-light-gray d-flex justify-content-center flex-grow-1'>NOT DISPUTING</span>
        </div>
      );
    }
  };

  // Define columns for react-table
  const columns = React.useMemo(
    () => [
      {
        Header: <span className='fifth-step'>Account Name</span>,
        id: 1,
        accessor: data => <span dangerouslySetInnerHTML={{ __html: data.name }}></span>,
        className: 'fifth-step',
      },
      {
        Header: <span className='sixth-step'>Account #</span>,
        id: 2,
        accessor: data => data.ex_account_number || data.eq_account_number || data.tr_account_number,
        className: 'text-dark-blue text-regular-16 sixth-step',
      },
      {
        Header: <span className='seventh-step'>Account Type</span>,
        id: 3,
        accessor: data => {
          if (data.type === 'Open Account') {
            return data.payment_type;
          } else if (data.type === 'INC IN BANKRUPTCY') {
            return 'Public Record';
          } else {
            return data.type;
          }
        },
      },
      {
        Header: <span className='account-status'>Account Status</span>,
        id: 4,
        accessor: data => data.payment_type === 'INC IN BANKRUPTCY' ? "Bankruptcy" : data.payment_type,
        disableSortBy: true,
      },

      {
        Header: <span className='reporting-date'>Reporting Date</span>,
        id: 5,
        accessor: data => moment(data.reported_date).format('MM/DD/YYYY'),
      },
      {
        Header: <span className='dispute-date'>Dispute Month</span>,
        accessor: 'dispute_dates',
        // Define custom sorting function for dispute dates
        sortType: (rowA, rowB, columnId) => {
          const dateA = moment(rowA.values[columnId][0].full_report_date);
          const dateB = moment(rowB.values[columnId][0].full_report_date);
          return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
        },
      },
      {
        Header: <div className='bureaus-dispute-items'>Bureaus</div>,
        id: 'Bureaus',
        accessor: data => [data.Experian, data.Equifax, data.Transunion],
        disableSortBy: true, // Disable sorting for this column
      },
    ],
    []
  );

  const data = React.useMemo(() => dispute_letter_right_list, [dispute_letter_right_list]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

  return (
    <Table {...getTableProps()} borderless responsive id='inDispute' style={{ tableLayout: 'auto' }}>
      <thead className='rounded-3 fourth-step' style={{ backgroundColor: 'rgb(248, 249, 253)' }}>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                style={{
                  color: 'var(--bs-gray-400)',
                  fontWeight: '300',
                  cursor: 'pointer',
                }}>
                {' '}
                {column.id === 'Bureaus' ? (
                  <div className='d-flex justify-content-between bureaus-dispute-items'>
                    <img src={ExperianIcon} alt='Experian' style={{ maxHeight: '20px' }} />
                    <img src={EquifaxIcon} alt='Equifax' style={{ height: '10px', marginTop: '7px' }} />
                    <img src={TransUnionIcon} alt='TransUnion' style={{ maxHeight: '20px' }} />
                  </div>
                ) : (
                  column.render('Header')
                )}
                {column.isSorted ? <img src={column.isSortedDesc ? DescSort : AscSort} alt={column.isSortedDesc ? 'Descending' : 'Ascending'} style={{ width: '15px', height: '15px', marginLeft: '.5rem' }} /> : ''}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                if (cell.column.id === 'dispute_dates') {
                  // Custom rendering for dispute dates
                  return (
                    <td {...cell.getCellProps()}>
                      <div className='d-flex flex-row'>
                        {cell.value.map((date, index) => (
                          <div style={{ height: '55px', width: '55px', margin: 'auto', position: 'relative' }} className={`p-1 rounded-4 d-flex justify-content-center align-items-center ${date.package_id === '2' ? 'bg-icon-blue' : 'bg-icon-white border border-light-gray border-2'} `}>
                            {date.package_id === '2' && <img src={GoldStar} alt='gold star' stroke='2' style={{ height: '12px', position: 'absolute', top: '5px', right: '3px', color: 'gold' }} />}
                            <div style={{ width: '40px', margin: 'auto', textAlign: 'center' }} className={`lh-1 ${date.package_id === '2' ? 'text-white' : 'text-light-gray'} fs-16`}>
                              <div>{moment(date.full_report_date).format('MMM').toUpperCase()}</div>

                              <div>{moment(date.full_report_date).format('YYYY')}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </td>
                  );
                } else if (cell.column.id === 'Bureaus') {
                  // Custom rendering for Bureaus
                  return (
                    <td {...cell.getCellProps()}>
                      <div className='d-flex flex-row justify-content-between w-100 my-3'>
                        {getIconBeuro(cell.value[0])}
                        {getIconBeuro(cell.value[1])}
                        {getIconBeuro(cell.value[2])}
                      </div>
                    </td>
                  );
                } else {
                  // Default rendering for other cells
                  return (
                    <td {...cell.getCellProps()} className='text-dark-blue text-regular-16'>
                      {cell.render('Cell')}
                    </td>
                  );
                }
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default InDispute;
